import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useRef } from "react";
import {
  progressBarContainerSx,
  getProgressBarFillSx,
  progressBarTrackSx,
  scrollContainerSx,
  sectionContainerSx,
  stickyContainerSx,
  titleSx,
  emblaViewportSx,
  emblaContainerSx,
  indicatorsContainerSx,
  getIndicatorSx,
  cardsWithProgressWrapperSx,
} from "./NextStepsSection.sx";
import { StepCard } from "./StepCard";
import { cardsData } from "./NextStepsSection.config";
import { useNextStepCarousel } from "./useNextStepCarousel";
import { useNextStepAnimation } from "./useNextStepAnimation";

export const NextStepsSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  // Wrapper ref for scroll animation - includes carousel and progress bar
  const wrapperRef = useRef<HTMLDivElement>(null);

  const {
    emblaRef,
    selectedIndex,
    activeCardIndex,
    snapCount,
    isThumbDragging,
    trackRef,
    handleThumbPointerDown,
    handleThumbPointerMove,
    handleThumbPointerUp,
    handleTrackClick,
    handleIndicatorClick,
  } = useNextStepCarousel();

  useNextStepAnimation({
    sectionRef,
    targetRef: wrapperRef,
  });

  return (
    <Box
      component="section"
      id="next-steps"
      ref={sectionRef}
      sx={scrollContainerSx}
    >
      <Box sx={stickyContainerSx}>
        <Box sx={sectionContainerSx}>
          <Typography component="h2" sx={titleSx}>
            Next Steps
          </Typography>

          {/* Wrapper for carousel + progress bar - animated together on scroll */}
          <Box ref={wrapperRef} sx={cardsWithProgressWrapperSx}>
            {/* Embla carousel container */}
            <Box sx={emblaViewportSx} ref={emblaRef}>
              <Box sx={emblaContainerSx}>
                {cardsData.map((card, index) => (
                  <StepCard
                    key={card.id}
                    index={index}
                    selectedIndex={activeCardIndex}
                    {...card}
                  />
                ))}
              </Box>
            </Box>

            {/* Desktop progress bar */}
            <Box sx={progressBarContainerSx}>
              <Box
                ref={trackRef}
                sx={progressBarTrackSx}
                onPointerDown={handleTrackClick}
              >
                <Box
                  onPointerDown={handleThumbPointerDown}
                  onPointerMove={handleThumbPointerMove}
                  onPointerUp={handleThumbPointerUp}
                  onPointerCancel={handleThumbPointerUp}
                  sx={getProgressBarFillSx({
                    snapCount,
                    selectedIndex,
                    isThumbDragging,
                  })}
                />
              </Box>
            </Box>

            {/* Mobile carousel indicators */}
            <Stack direction="row" gap={1} sx={indicatorsContainerSx}>
              {cardsData.map((card, index) => (
                <Box
                  key={card.id}
                  onClick={() => handleIndicatorClick(index)}
                  sx={getIndicatorSx(index === activeCardIndex)}
                />
              ))}
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NextStepsSection;
